<template>
  <div>
    <!--编辑 -->
    <el-dialog title="编辑" :visible.sync="dialog" @close="unShowClick()">
      <el-form ref="addBody" :rules="rules" :model="addBody">
        <el-form-item label="管理员姓名" prop="nickname" :label-width="formLabelWidth">
          <el-input v-model="addBody.nickname"/>
        </el-form-item>
        <el-form-item label="手机号码" prop="mobile" :label-width="formLabelWidth">
          <el-input placeholder="请输入管理员联系方式" v-model="addBody.mobile"/>
        </el-form-item>
        <el-form-item prop="username" label="管理员账号" :label-width="formLabelWidth">
          <el-input v-model="addBody.username"/>
        </el-form-item>
        <el-form-item label="管理员密码" prop="password" :label-width="formLabelWidth">
          <el-input type="password" v-model="addBody.password"/>
        </el-form-item>
        <el-form-item prop="group_id" label="管理员身份" :label-width="formLabelWidth">
          <el-select v-model="roleUuid" @change="changeItem">
            <el-option v-for="(item,index) in identTable" :key="item.group_id" :label="item.group_title"
                       :value="item.group_id"/>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="unShowClick()">取 消</el-button>
        <el-button type="primary" @click="editUser('addBody')">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  getIdentityselect,
  getAuthListDetail,
  editAuthUser,
  addAdminUser, identityOf
} from '@/api/auth'
// import { getAuthListDetail, identityOf, editAuthUser } from '@/api/auth'

export default {
  props: {
    uuid: {
      type: Object,
      default: {},
    },
    value: {
      type: Boolean,
      default: false,
    },
    dialogProp: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    var validateroleUuid = (rule, value, callback) => {
      if (!this.roleUuid) {
        return callback(new Error("请输入管理员身份"))
      } else {
        return callback()
      }
    };
    return {
      readid: '',
      dialog: false,
      identTable: [],
      formLabelWidth: '120px',
      isAddAdmin: true,
      addBody: {
        username: '',
        password: '',
        nickname: '',
        mobile: '',
        roleUuid: '',
        group_id: '',
      },
      roleUuid: "",
      rules: {
        nickname: [{
          required: true,
          message: '请输入管理员账号',
          trigger: 'blur'
        },],
        mobile: [{
          required: true,
          message: '请输入管理员联系方式',
          trigger: 'blur'
        },],
        username: [{
          required: true,
          message: '请输入管理员账号',
          trigger: 'blur'
        },],
        // password: [{
        //   required: true,
        //   message: '请输入管理员账号密码',
        //   trigger: 'blur'
        // },],
        group_id: [{
          required: true,
          validator: validateroleUuid,
          trigger: 'blur'
        },],
      },
    }
  },
  mounted() {
    this.isAddAdmin = true;
  },
  methods: {
    changeItem(item) {
      this.addBody.roleUuid = item;
    },
    editUser(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          console.log(this.isAddAdmin);
          if (this.isAddAdmin) {
            this.network().addAuthUser()
          } else {
            this.network().editAuthUser()
          }
          this.dialog = false
          this.$emit('confirm', false)
        } else {
          console.log('error submit!!');
          return false;
        }
        return false
      });
    },
    unShowClick() {
      this.$emit('input', false)
    },
    network() {
      return {
        // 管理员详细信息
        getAuthListDetail: async () => {
          console.log('详情数据', this.readid)
          const {
            status,
            data
          } = await getAuthListDetail({
            admin_id: this.readid
          })
          if (status !== 200) return
          this.roleUuid = data.result.group_id
          this.readid = data.result.admin_id

          this.addBody.username = data.result.username
          this.addBody.password = data.result.password
          this.addBody.nickname = data.result.nickname
          this.addBody.mobile = data.result.mobile
        },
        // 管理员身份
        identityOf: async () => {
          let postData = {
            page_index: 1,
            page_size: 99999
          };
          const {
            data,
            status
          } = await identityOf(postData)
          if (status !== 200) return
          this.identTable = [];
          this.identTable = data.result.data;
        },
        // 添加管理员
        addAuthUser: async () => {
          const {
            status
          } = await addAdminUser({
            head_pic: '123',
            status: 1,
            nickname: this.addBody.nickname,
            username: this.addBody.username,
            password: this.addBody.password,
            group_id: this.roleUuid,
            mobile: this.addBody.mobile,
          })
          if (status !== 200) return
          this.$emit('confirm')

        },
        // 编辑管理员
        editAuthUser: async () => {
          const {
            status
          } = await editAuthUser({
            // nickname  mobile username group_id
            admin_id: this.readid,
            head_pic: '123',
            nickname: this.addBody.nickname,
            username: this.addBody.username,
            password: this.addBody.password,
            group_id: this.roleUuid,
            mobile: this.addBody.mobile,
          })
          if (status !== 200) return
          this.$emit('confirm')
        },
      }
    },
  },

  watch: {
    uuid(val) {
      this.isAddAdmin = true;
      this.addBody = {};
      this.roleUuid = "";
      if (Object.keys(val).length != 0) {
        console.log(val)
        this.isAddAdmin = false;

        this.readid = val.admin_id;
        this.addBody = val;

        this.roleUuid = val.group_id
        this.network().getAuthListDetail()
      }
      this.network().identityOf()
    },
    value(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.dialog = newVal

        this.network().getAuthListDetail()
      }
    },
    dialogProp(old) {
      this.dialog = old;
    },

  },
};
</script>

<style scoped>
</style>
